// TESTIMONIAL TABS JS
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-item");
  const testimonials = document.querySelectorAll(".testimonial");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const target = this.getAttribute("data-target");

      // Remove 'active' class from all testimonials
      testimonials.forEach((testimonial) => {
        testimonial.classList.remove("active");
      });

      // Add 'active' class to the target testimonial
      document.getElementById(target).classList.add("active");

      // Remove 'active' class from all tabs
      tabs.forEach((tab) => {
        tab.classList.remove("active");
      });

      // Add 'active' class to the clicked tab
      this.classList.add("active");
    });
  });

  // Activate the first tab by default
  if (tabs.length > 0) {
    tabs[0].click();
  }
});

// TESTIMONIAL VIDEO CAROUSEL
const swiperr = new Swiper(".swiperr-container", {
  slidesPerView: 2,
  slidesPerGroup: 1,
  centeredSlides: false,
  spaceBetween: 10,
  loop: true,
  touchRatio: 1,
  resistanceRatio: 0.85,
  freeMode: false,
  watchOverflow: true,
  navigation: {
    nextEl: ".custom-next", // Updated to use your custom buttons
    prevEl: ".custom-prev", // Updated to use your custom buttons
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 10,
      loop: true,
    },
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 20,
      loop: false,
    },
  },
});

// Add click event listeners to videos
document.querySelectorAll(".swiper-slide video").forEach((video) => {
  video.addEventListener("click", () => {
    // Pause all other videos when one is clicked
    document.querySelectorAll(".swiper-slide video").forEach((v) => {
      if (v !== video) {
        v.pause();
        v.nextElementSibling.style.display = "flex";
      }
    });

    // Toggle play/pause for the clicked video
    if (video.paused) {
      video.play();
      video.nextElementSibling.style.display = "none";
    } else {
      video.pause();
      video.nextElementSibling.style.display = "flex";
    }
  });

  // Show play icon when video ends
  video.addEventListener("ended", () => {
    video.nextElementSibling.style.display = "flex";
  });
});

// Ensure play icon is visible and clickable
document.querySelectorAll(".play-icon").forEach((icon) => {
  icon.addEventListener("click", (event) => {
    const video = event.target.closest(".swiper-slide").querySelector("video");
    if (video) {
      // Pause all other videos when play icon is clicked
      document.querySelectorAll(".swiper-slide video").forEach((v) => {
        if (v !== video) {
          v.pause();
          v.nextElementSibling.style.display = "flex";
        }
      });

      if (video.paused) {
        video.play();
        icon.style.display = "none";
      } else {
        video.pause();
        icon.style.display = "flex";
      }
    }
  });
});

// Custom Swiper button click handling to disable/enable buttons
const prevButton = document.querySelector('.custom-prev');
const nextButton = document.querySelector('.custom-next');

if (prevButton && nextButton) {
  prevButton.addEventListener('click', () => {
    swiperr.slidePrev();
  });

  nextButton.addEventListener('click', () => {
    swiperr.slideNext();
  });
}

  // CUSTOM FREE SHIPPING BAR
  document.addEventListener("DOMContentLoaded", function () {
    function updateProgressBar() {
      let progressBar = document.querySelector(".progress-bar");
      let progressContainer = document.querySelector(".progress-container");
      let freeShippingIcon = document.querySelector(".free-shipping");
      let discountIcon = document.querySelector(".discount");
  
      if (!progressBar || !progressContainer) return;
  
      let newProgress = parseFloat(progressBar.getAttribute("data-progress")) || 0;
  
      // Get stored progress from localStorage if available
      let storedProgress = parseFloat(localStorage.getItem("progressBarLastValue")) || 0;
  
      // Ensure the progress doesn't reset to 0 if Shopify re-renders the cart
      let currentWidth = parseFloat(progressBar.style.width.replace("%", "")) || storedProgress;
  
      // Save new progress in localStorage
      localStorage.setItem("progressBarLastValue", newProgress);
  
      // Set progress instantly without animation
      progressBar.style.width = newProgress + "%";
  
      // ✅ Change Free Shipping Icon when progress >= 70%
      if (newProgress >= 65) {
        freeShippingIcon.classList.add("progress-reached");
      } else {
        freeShippingIcon.classList.remove("progress-reached");
      }
  
      // ✅ Change Discount Icon when progress = 100%
      if (newProgress >= 100) {
        discountIcon.classList.add("progress-reached");
      } else {
        discountIcon.classList.remove("progress-reached");
      }
    }
  
    // Run update on load
    updateProgressBar();
  
    // Fix Shopify AJAX cart reset issue
    document.addEventListener("cart:updated", function () {
      setTimeout(updateProgressBar, 100); // Ensure progress updates after cart re-renders
    });
  });